import { useTranslate } from '@refinedev/core';
import { Typography, Divider } from 'antd';
import { CollectionData } from '@/api/generated/schemas';
import type {
  CollectionFilterGroupIn,
  CollectionFilterGroupOut,
  CollectionSortRuleOut,
} from '@/api/generated/schemas';
import { CollectionFilterSummary } from './CollectionFilterSummary';
import { CollectionSortingShow } from './CollectionSortingShow';

const { Title, Text } = Typography;

interface Props {
  collectionData?: CollectionData;
  filters?: CollectionFilterGroupOut | null;
  sorting?: CollectionSortRuleOut[] | null;
  limit?: number | null;
}

/** Read-only render of a dynamic collection's filter/sort/limit configuration. */
export const CollectionFilterShow = ({
  collectionData,
  filters,
  sorting,
  limit,
}: Props) => {
  const t = useTranslate();

  const sortingBlock = (
    <>
      <Title level={5} style={{ marginTop: 16 }}>
        {t('base.collection.sorting')}
      </Title>
      <CollectionSortingShow sorting={sorting} />
    </>
  );

  // Static collections have no filters or limit, but they do carry a sort order.
  if (collectionData !== CollectionData.dynamic) {
    return (
      <>
        <Divider />
        {sortingBlock}
      </>
    );
  }

  return (
    <>
      <Divider />
      <Title level={4}>{t('base.collection.dynamic_filters')}</Title>

      <Title level={5} style={{ marginTop: 16 }}>
        {t('base.collection.filters')}
      </Title>
      <CollectionFilterSummary
        value={(filters as CollectionFilterGroupIn) ?? null}
      />

      {sortingBlock}

      <Title level={5}>{t('base.collection.limit')}</Title>
      <Text>{limit ?? '-'}</Text>
    </>
  );
};
